export const environment = {
  production: true,
  //apiUrl:"http://ec2-13-251-127-135.ap-southeast-1.compute.amazonaws.com:5000/",
  apiUrl: 'http://52.77.45.69:5000/',
  // apiUrl: 'http://localhost:5000/',
  kraApi: 'http://52.66.212.246:3100/api/v1/',

  firebaseMobilityConfig: {
    apiKey: 'AIzaSyCM3miOA2axwdTuhIwOxnRp-w816NSu0Wk',
    authDomain: 'ecoclean-mobility.firebaseapp.com',
    databaseURL: 'https://ecoclean-mobility.firebaseio.com',
    projectId: 'ecoclean-mobility',
    storageBucket: 'ecoclean-mobility.appspot.com',
    messagingSenderId: '164954315507',
    appId: '1:164954315507:web:623bbe7dfc172194b7b586',
  },
}



// WEBPACK FOOTER //
// ./src/environments/environment.ts